import { render, staticRenderFns } from "./ProfileAddress.vue?vue&type=template&id=6a8c4fca&scoped=true&"
import script from "./ProfileAddress.vue?vue&type=script&lang=js&"
export * from "./ProfileAddress.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAddress.vue?vue&type=style&index=0&id=6a8c4fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8c4fca",
  null
  
)

export default component.exports